/*
----------------------------------------------------------------------------
Usage:
----------------------------------------------------------------------------
import ClipboardCopy from './modules/clipboard-copy'
_('clipboardcopy', 'element').nodes().map((el) => new ClipboardCopy(el))
*/

class ClipboardCopy {
    constructor(el) {
        this.el = el
        this.value = this.el.dataset.value
        if (this.value !== null) {
            this.el.addEventListener('click', this.addToClipboard)
        }
    }

    addToClipboard = () => {
        navigator.clipboard.writeText(this.value)
    }
}
export default ClipboardCopy
